module.exports = __webpack_public_path__ + "static/media/puantaj_icon.b765c164.png";